import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { userApi, getUser } from "../lib/api";

const PREFIX_RE = /^\(\d+\+?\)\s+/;

// Refleja los pendientes del usuario en el ícono de la app instalada (PWA badge)
// y en el título de la pestaña del navegador, aunque no esté en el dashboard.
export function AppBadgeManager() {
  const location = useLocation();
  const countRef = useRef(0);

  useEffect(() => {
    let stop = false;

    const stripPrefix = (t) => (t || "").replace(PREFIX_RE, "");
    const applyTitle = () => {
      const n = countRef.current;
      const base = stripPrefix(document.title) || "SUPERA Leadership";
      const desired = n > 0 ? `(${n > 99 ? "99+" : n}) ${base}` : base;
      if (document.title !== desired) document.title = desired;
    };
    const applyBadge = () => {
      const n = countRef.current;
      try {
        if ("setAppBadge" in navigator) {
          if (n > 0) navigator.setAppBadge(n);
          else navigator.clearAppBadge?.();
        }
      } catch (_) { /* noop */ }
    };

    // Mantiene el prefijo aunque otra parte cambie el título de la pestaña.
    const observer = new MutationObserver(() => applyTitle());
    const titleEl = document.querySelector("title");
    if (titleEl) observer.observe(titleEl, { childList: true });

    const refresh = async () => {
      const u = getUser();
      if (!u || u.role === "admin") { countRef.current = 0; applyBadge(); applyTitle(); return; }
      try {
        const b = await userApi.dashboardBadges();
        if (stop) return;
        countRef.current = b?._total || 0;
        applyBadge();
        applyTitle();
      } catch (_) { /* noop */ }
    };

    refresh();
    const iv = setInterval(refresh, 45000);
    const onVis = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVis);

    return () => { stop = true; clearInterval(iv); observer.disconnect(); document.removeEventListener("visibilitychange", onVis); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
